import { css } from '@emotion/css';

type ServerErrorPageProps = {
    status: number | boolean
    text: string | boolean
}

// eslint-disable-next-line unused-imports/no-unused-vars
const ServerErrorPage = ({ status, text }: ServerErrorPageProps) => {
    return (
        <div className={styles.content}>
            <div>
                Status Code: <i>{status}</i>
                <br />
                Projekt PLANETDIET serveren svarer ikke i øjeblikket – Vi er opmærksomme på fejlen. Oplever du denne fejl i mere end 24 timer bedes du tage kontakt:
                <br />
                <br />
                Telefon: +45 93 51 84 39 (telefontid man-fre kl. 9:00 - 16:00)
                <br />
                <br />
                Email: PLANETDIET@sund.dk
            </div>
        </div>
    );
};

const styles = {
    content: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '7rem',
    }),
};

export default ServerErrorPage;
